/**
 * @author Jersson Stiven Morales Alza
 * @Copyright (c) Infotrack. All rights reserved.
 */
import notificacionGlobal from '@infotrack/presentacion-componentes/notificacionGlobal';
import ModeloTiposClientes from 'Infotrack@Modelos/smartStock/tiposClientes';
import ITiposClientes from 'Infotrack@Modelos/smartStock/tiposClientes/entidades/tiposClientes';

export default class ControladorModeloTiposClientes {
    private modeloTiposClientes: ModeloTiposClientes;
    constructor() {
        this.modeloTiposClientes = new ModeloTiposClientes();
    }

    public consultarTiposClientes() {
        return this.modeloTiposClientes.consultarTiposClientes().then(({ data: { Entidades } }) => Entidades);
    }

    public async crearTiposClientes(tiposClientes: ITiposClientes) {
        await this.modeloTiposClientes.crearTiposClientes(tiposClientes);
    }

    public async editarTiposClientes(tiposClientes: ITiposClientes) {
        await this.modeloTiposClientes.editarTiposClientes(tiposClientes);
    }
    public async eliminarTiposClientes(tiposClientes: ITiposClientes) {
        await this.modeloTiposClientes.eliminarTiposClientes(tiposClientes);
    }

    public async consultarListaTiposClientePorEmpresaId(EmpresaId: string) {
        return this.modeloTiposClientes.consultarTiposClientesPorFiltro({EmpresaId}).then(({ data: { Entidades } }) => Entidades);
    }

    public validarEntidad(tiposClientes: ITiposClientes): boolean {
        if (tiposClientes.TipoClienteDescripcion === '') {
            notificacionGlobal('Por favor ingrese todos los campos requeridos (*)', 6000, 'warning', true);
            return false;
        }
        return true;
    }
}
